import React, { useContext, useEffect, useState } from "react";
import { Row, Col, Pagination, Offcanvas, Card, Form } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import DeleteModal from "../../components/common/DeleteModel";
import { UserContext } from "../../context/UserContextProvider";
import APIServicenew from "../../utils/APIGeneralService";
import { formatDateTime } from "../../utils/Helper";
import { ToastContainer, toast } from "react-toastify";
import useMenuPermissions from "../../components/CustomHook/custompermission";

const ChannelDetails = () => {
  const { id } = useParams();
  const [channelDetails, setChannelDetails] = useState();
  const [rmDetailsList, setRmDetailsList] = useState([]);
  const [selectedId, setSelectedId] = useState("");
  const [showDt, setShowDt] = useState(false);
  const APIServices = new APIServicenew(process.env.REACT_APP_OTHER_API_URL);
  const authToken = process.env.REACT_APP_authToken;
  const { accessToken, logout } = useContext(UserContext);
  const headers = { "auth-token": authToken, authorization: accessToken };
  const permissionscontext = useMenuPermissions('/admin/channel-partner');
  const navigate = useNavigate();

  useEffect(() => {
    fetchChDetails();
  }, []);

  const fetchChDetails = async () => {
    try {
      const response = await APIServices.get(
        `/admin/channel_partner/details/${id}`,
        headers
      );
      if (response?.status === 200) {
        setChannelDetails(response?.data?.details || []);
        setRmDetailsList(response?.data?.relationshipManagers || []);
      } else if (response?.status === 401) {
        logout();
        navigate("/");
      } else {
        setChannelDetails({});
      }
    } catch (error) {
      setChannelDetails({});
    }
  };

  const handleDeleteChPartner = async () => {
    try {
      if (selectedId !== null) {
        const payload = { id: selectedId };
        const res = await APIServices.post(
          `/admin/channel_partner/delete`,
          payload,
          headers
        );
        if (res?.data?.status === true) {
          showToast(res?.data?.message || "Success", "success");
          navigate("/admin/channel-partner");
          setSelectedId(null);
        } else {
          showToast(res?.data?.message || "Something went wrong.", "error");
        }
      }
      setShowDt(false);
    } catch (error) {
      console.error("Error deleting FAQ:", error);
    }
  };

  const handleStatusChange = async (chPatner) => {
    const newStatus = chPatner.status === "Active" ? "Inactive" : "Active";
    try {
      const payload = { id: chPatner.id, status: newStatus };
      const res = await APIServices.post(
        `/admin/channel_partner/status_update`,
        payload,
        headers
      );
      if (res?.data?.status === true) {
        showToast(res?.data?.message || "Success", "success");
        fetchChDetails()
      } else {
        showToast(res?.data?.message || "Something went wrong.", "error");
      }
    } catch (error) {
      showToast("Error updating status", "error");
    }
  };

  const showToast = (message, type) => {
    toast(message, {
      position: "top-right",
      autoClose: 2000,
      type,
      hideProgressBar: false,
      closeOnClick: true,
    });
  };

  return (
    <>
      <div className="channel_details_inner">
        <h2 className="font_blue_18 font-600 mb-3">Channel Partner Details</h2>

        <div className="channel_details ">
          <div className="cd_header">
            <Row className="align-items-center">
              <Col md={8}>
                <div class="ch_name d-flex align-items-center">
                  <p className="font_blue_18 font-500 textTransform">
                    {channelDetails?.name}
                  </p>
                </div>
              </Col>
              <Col md={4}>
                <ul className="d-flex align-items-center justify-content-end gap-2">
                  <li>
                    <button
                      disabled={!permissionscontext.delete}
                      style={{
                        border: "none",
                        background: "transparent",
                        padding: 0,
                        cursor: !permissionscontext.delete
                          ? "not-allowed"
                          : "pointer",
                        opacity: !permissionscontext.delete ? 0.5 : 1,
                      }}
                      onClick={() => {
                        setSelectedId(channelDetails.id);
                        setShowDt(true);
                      }}
                    >
                      <img
                        src="/images/Trash.svg"
                        className="img-fluid trash"
                        alt="trash"
                      />
                    </button>
                  </li>
                  <li>
                    <button
                      disabled={!permissionscontext.edit}
                      style={{
                        border: "none",
                        background: "transparent",
                        padding: 0,
                        cursor: !permissionscontext.edit
                          ? "not-allowed"
                          : "pointer",
                        opacity: !permissionscontext.edit ? 0.5 : 1,
                      }}
                      onClick={() =>
                        navigate(`/admin/update-channel/${channelDetails.id}`, {
                          state: { row: channelDetails },
                        })
                      }
                    >
                      <img
                        src="/images/Pen.svg"
                        className="img-fluid pen"
                        alt="pen"
                      />
                    </button>
                  </li>
                </ul>
              </Col>
            </Row>
          </div>

          <div className="cd_body mt-4">
            <Row className="all_details">
              <Col md={4} lg={4}>
                <div>
                  <h4 className="font_blue_16 font-500 mb-2">
                    Registered Date
                  </h4>
                  <p className="font_blue_16 ">
                    {formatDateTime(channelDetails?.created)}
                  </p>
                </div>
              </Col>
              <Col md={4} lg={4}>
                <div>
                  <h4 className="font_blue_16 font-500 mb-2">Phone No</h4>
                  <p className="font_blue_16 ">{channelDetails?.mobile
                    ? `( ${channelDetails?.country_code}) ${channelDetails?.mobile}`
                    : 'N/A'}</p>
                </div>
              </Col>
              <Col md={4} lg={4}>
                <div>
                  <h4 className="font_blue_16 font-500 mb-2">Email ID</h4>
                  <p className="font_blue_16 ">{channelDetails?.email ? channelDetails?.email : "N/A"}</p>
                </div>
              </Col>
              <Col md={4} lg={4}>
                <div>
                  <h4 className="font_blue_16 font-500 mb-2">Region</h4>
                  <p className="font_blue_16 ">{channelDetails?.region_name}</p>
                </div>
              </Col>
              <Col md={4} lg={4}>
                <div>
                  <h4 className="font_blue_16 font-500 mb-2">Status</h4>
                  <p className="font_blue_16 d-flex align-items-center">
                    {channelDetails?.status}{" "}
                    <Form className="Switch_toggle ms-2 position-relative">
                      <input
                        type="checkbox"
                        id={`switch-${channelDetails?.id}`}
                        checked={channelDetails?.status === "Active"}
                        onClick={() => handleStatusChange(channelDetails)}
                        disabled={!permissionscontext.edit}
                      />
                      <label
                        htmlFor={`switch-${channelDetails?.id}`}
                        className="position-absolute"
                      >
                        Toggle
                      </label>
                    </Form>
                  </p>
                </div>
              </Col>
              <Col md={4} lg={4}>
                <div>
                  <h4 className="font_blue_16 font-500 mb-2">Type</h4>
                  <p className="font_blue_16 round_border">
                    {channelDetails?.channel_partner_type}
                  </p>
                </div>
              </Col>
              <Col md={12} lg={12}>
                <div>
                  <h4 className="font_blue_16 font-500 mb-2">Location</h4>
                  <p className="font_blue_16 ">
                    {` ${channelDetails?.address},${channelDetails?.city_name} (${channelDetails?.state_name}), ${channelDetails?.country_name}, ${channelDetails?.pin_code}`}
                  </p>
                </div>
              </Col>
              <Col md={12} lg={12}>
                <div>
                  <h4 className="font_blue_16 font-500 mb-2">Details</h4>
                  <p className="font_blue_16 ">{channelDetails?.description}</p>
                </div>
              </Col>
            </Row>

            {rmDetailsList.length > 0 && (
              <div className="member_list_sec mt-4">
                <h4 className="font_blue_16 font-500 mb-2">{`Members (${rmDetailsList?.length})`}</h4>

                <ul className="mamber_list">
                  {rmDetailsList?.map((rm, index) => (
                    <li key={rm.id}>
                      <ul className="d-flex align-items-center">
                        <li className="sr_n font_blue_14">{index + 1}</li>
                        <li className="user">
                          <div class="d-flex align-items-center">
                            {
                              rm?.profile_pic ?
                                <img
                                  className="img-fluid me-2 table_user rounded-circle"
                                  alt="rm profile"
                                  src={rm?.profile_pic}
                                  onError={(e) => (e.target.src = "/images/placeholder-img.jpg")}
                                />
                                :
                                <img src="/images/placeholder-img.jpg"
                                  className='img-fluid me-2 table_user'
                                  alt="default img"
                                />
                            }

                            <p className="font_blue_14 textTransform">{`${rm?.first_name} ${rm?.last_name}`}</p>
                          </div>
                        </li>
                        <li className="designation font_blue_14">
                          {rm?.email ? rm?.email : "N/A"}
                        </li>
                        <li className="designation font_blue_14">
                          {rm?.mobile
                            ? `( ${rm?.country_code}) ${rm?.mobile}`
                            : 'N/A'}
                        </li>
                      </ul>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>
      <DeleteModal
        showdt={showDt}
        handleCloseDt={() => setShowDt(false)}
        handledelete={handleDeleteChPartner}
      />
      <ToastContainer />
    </>
  );
};

export default ChannelDetails;
